import { useMemo, useState } from 'react';
import moment from 'moment';
import AtlasEmptyState from './AtlasEmptyState';
import { ONBOARDING_COPY } from './onboardingCopy';
import AvButton from '../nedi/AvButton';
import NediRowButton from '../nedi/NediRowButton';
import '../nedi/nediAnatomy.css';
import './Buttons.css';
import './DiaWorkspace.css';

// Workspace "Dia" — calendário content + stream com chrome Nedi (2.3).
function DiaWorkspace({
  selectedDate,
  dayEvents = [],
  eventDays,
  onSelectDay,
  onSelectEvent,
  onImportData,
}) {
  const base = selectedDate ? moment(selectedDate) : moment();
  const [monthCursor, setMonthCursor] = useState(base.clone().startOf('month'));

  const grid = useMemo(() => {
    const start = monthCursor.clone().startOf('month').startOf('week');
    const end = monthCursor.clone().endOf('month').endOf('week');
    const days = [];
    const cursor = start.clone();
    while (cursor.isSameOrBefore(end, 'day')) {
      days.push(cursor.clone());
      cursor.add(1, 'day');
    }
    return days;
  }, [monthCursor]);

  const selectedKey = base.format('YYYY-MM-DD');

  return (
    <div className="av-dia" aria-label="Workspace Dia" data-nedi-workspace="dia">
      <div className="av-dia-calendar">
        <div className="av-dia-cal-header">
          <AvButton
            type="button"
            variant="icon"
            className="av-dia-cal-nav"
            onClick={() => setMonthCursor((m) => m.clone().subtract(1, 'month'))}
          >
            <span className="av-sr-only">Mês anterior</span>
            <span aria-hidden="true">‹</span>
          </AvButton>
          <strong>{monthCursor.format('MMMM YYYY')}</strong>
          <AvButton
            type="button"
            variant="icon"
            className="av-dia-cal-nav"
            onClick={() => setMonthCursor((m) => m.clone().add(1, 'month'))}
          >
            <span className="av-sr-only">Próximo mês</span>
            <span aria-hidden="true">›</span>
          </AvButton>
        </div>
        <div className="av-dia-cal-grid">
          {['D', 'S', 'T', 'Q', 'Q', 'S', 'S'].map((d, i) => (
            <span key={i} className="av-dia-cal-dow">{d}</span>
          ))}
          {grid.map((day) => {
            const key = day.format('YYYY-MM-DD');
            const inMonth = day.isSame(monthCursor, 'month');
            const hasEvents = eventDays ? eventDays.has(key) : false;
            const isSelected = key === selectedKey;
            return (
              <button
                key={key}
                type="button"
                className={`av-dia-cal-day${inMonth ? '' : ' is-out'}${isSelected ? ' is-selected' : ''}`}
                aria-pressed={isSelected}
                aria-label={day.format('DD/MM/YYYY')}
                onClick={() => onSelectDay && onSelectDay(day.toDate())}
              >
                {day.date()}
                {hasEvents && <span className="av-dia-cal-dot" aria-hidden="true" />}
              </button>
            );
          })}
        </div>
      </div>

      <div className="av-dia-stream">
        <h2 className="av-dia-stream-title">{base.format('dddd, DD [de] MMMM')}</h2>
        {dayEvents.length === 0 ? (
          <AtlasEmptyState
            {...ONBOARDING_COPY.diaEmpty}
            actionLabel={onImportData ? ONBOARDING_COPY.diaEmpty.cta : undefined}
            onAction={onImportData}
            compact
            className="av-dia-stream-empty"
          />
        ) : (
          <ol className="nedi-row-stack av-dia-stream-list">
            {dayEvents.map((event, index) => (
              <li key={index} className="av-dia-stream-item">
                <NediRowButton
                  className="av-dia-stream-btn"
                  title={event.title}
                  subtitle={event.allDay ? 'Dia inteiro' : moment(event.start).format('HH:mm')}
                  leading={
                    <span
                      className="av-dia-stream-dot"
                      style={{ background: event.resource?.color || 'var(--sky)' }}
                    />
                  }
                  onClick={() => onSelectEvent && onSelectEvent(event)}
                />
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
}

export default DiaWorkspace;
